import { z } from "zod";
import { PaginationSchema } from "../../pagination/response/PaginationResponse";

export const AgentSchema = z.object({
    id: z.string().uuid(),
    property_id: z.string().uuid(),
    name: z.string(),
    color: z.string().regex(/^#[0-9A-Fa-f]{6}$/, "Invalid color code"),
    is_editable: z.number().int(),
    is_active: z.number().int(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    website: z.string().nullable(),
    email: z.string().email().nullable(),
    phone: z.string().nullable(),
});

export const AgentResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number().int(),
    data: z.array(AgentSchema),
    pagination: z.nullable(PaginationSchema).optional(),
});

export type AgentResponse = z.infer<typeof AgentResponseSchema>;
export type AgentData = z.infer<typeof AgentSchema>;
